import { render, staticRenderFns } from "./BodyForm.vue?vue&type=template&id=4aae5200&"
import script from "./BodyForm.vue?vue&type=script&lang=js&"
export * from "./BodyForm.vue?vue&type=script&lang=js&"
import style0 from "./BodyForm.vue?vue&type=style&index=0&id=4aae5200&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports